import type { ProcessDraftStep } from '@bliks-io/contracts';

/**
 * Expand a single `ruleId` on a decision step to every rule id that shares
 * its `output` label (inclusive of itself). Returns `[]` when the rule list
 * is missing or the target rule isn't in it — callers decide whether to
 * fall back to `[ruleId]`.
 *
 * The UI collapses same-output rules into one handle, so every write path
 * scoped to a single rule must fan out to the whole group to keep the data
 * model in sync with what the user sees.
 */
export function expandRuleIdToOutputGroup(
  rules: ProcessDraftStep['rules'] | undefined | null,
  ruleId: string
): string[] {
  if (!rules || rules.length === 0) return [];
  const target = rules.find((r) => r._id && String(r._id) === ruleId);
  if (!target) return [];
  const targetKey = (target.output ?? '').trim();
  return rules
    .filter((r) => r._id && (r.output ?? '').trim() === targetKey)
    .map((r) => String(r._id));
}
